(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function populateUTMFields() {
    var wrapper = document.getElementById('crmWebToEntityForm');
    if (!wrapper) return;

    var source = wrapper.dataset.defaultSource || '(direct)';
    var medium = wrapper.dataset.defaultMedium || '(none)';
    var campaign = wrapper.dataset.defaultCampaign || '';

    var raw = getCookie('jd_utm_params');
    if (raw) {
      try {
        var utm = JSON.parse(raw);
        if (utm.source) source = utm.source;
        if (utm.medium) medium = utm.medium;
        if (utm.campaign) campaign = utm.campaign;
      } catch (e) {}
    }

    var sourceField = document.getElementById('COBJ2CF7');
    var mediumField = document.getElementById('COBJ2CF11');
    var campaignField = document.getElementById('COBJ2CF9');

    if (sourceField) sourceField.value = source;
    if (mediumField) mediumField.value = medium;
    if (campaignField) campaignField.value = campaign;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', populateUTMFields);
  } else {
    populateUTMFields();
  }

  // Fire Meta pixel event when Zoho's success notification becomes visible
  var splash = document.getElementById('wf_splash');
  if (splash) {
    var splashObserver = new MutationObserver(function () {
      if (splash.style.display !== 'none') {
        splashObserver.disconnect();
        if (typeof fbq === 'function') {
          var formEl = document.getElementById('crmWebToEntityForm');
          var eventName = formEl && formEl.dataset.metaEvent;
          if (eventName) {
            fbq('trackCustom', eventName);
          } else {
            fbq('track', 'Lead');
          }
        }
      }
    });
    splashObserver.observe(splash, { attributes: true, attributeFilter: ['style'] });
  }
})();
